import { render, staticRenderFns } from "./S404.vue?vue&type=template&id=767a64e9&scoped=true"
import script from "./S404.vue?vue&type=script&lang=js"
export * from "./S404.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Pdis.css?vue&type=style&index=0&id=767a64e9&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767a64e9",
  null
  
)

export default component.exports